export default "__VITE_ASSET__CC5P7ugm__"